// @flow
/* eslint-disable no-param-reassign */
import maybeForEach from 'mz-utils/maybeForEach'
import FieldController from './FieldController'

// Types
import type { Meta } from '../../core/BaseField'

export { default as pickExcept } from 'mz-utils/pickExcept'

export function iterateChildrenTree<T: *>(meta: T, mutator: T => T): T {
  const newMeta = mutator(meta)

  if (newMeta.children) {
    const newChildren = {}
    Object.keys(newMeta.children).forEach(k => {
      newChildren[k] = iterateChildrenTree((newMeta.children: any)[k], mutator)
    })
    newMeta.children = newChildren
  }

  return newMeta
}

export function touchAllFields(meta: Meta): Meta {
  return iterateChildrenTree(meta, m => ({
    ...m,
    touched: true,
    deepTouched: true,
  }))
}

export function untouchAllFields(meta: Meta): Meta {
  return iterateChildrenTree(meta, m => ({
    ...m,
    touched: false,
    deepTouched: false,
  }))
}

export function lockAllFields(meta: Meta): Meta {
  return iterateChildrenTree(meta, m => ({
    ...m,
    locked: true,
  }))
}

export function unlockAllFields(meta: Meta): Meta {
  return iterateChildrenTree(meta, m => ({
    ...m,
    locked: false,
  }))
}

export function getAllControllers(
  controller: FieldController
): Array<FieldController> {
  const result = [controller]
  iterateChildrenTree(controller, c => {
    result.push(c)
    return c
  })
  return result
}

export function calculateDeepMeta(meta: Meta): Meta {
  const childrenKeys = (meta.children && Object.keys(meta.children)) || []

  meta.deepValid = meta.valid
  meta.deepActive = meta.active
  meta.deepTouched = meta.touched
  meta.deepLoading = meta.loading

  maybeForEach(childrenKeys, k => {
    const child = (meta.children: any)[k]
    meta.deepValid = !!(meta.deepValid && child.deepValid)
    meta.deepActive = !!(meta.deepActive || child.deepActive)
    meta.deepTouched = !!(meta.deepTouched || child.deepTouched)
    meta.deepLoading = !!(meta.deepLoading || child.deepLoading)
  })

  return meta
}
